import {
  RPL_LEAD_TITLE,
  buildRplFieldRows,
  getRplFromLead,
  isRplLead,
} from 'lib/rpl-leads';

type RplLeadDetailsProps = {
  lead: {
    content?: Record<string, any>;
    metadata?: Record<string, any>;
  };
};

export default function RplLeadDetails({ lead }: RplLeadDetailsProps) {
  if (!isRplLead(lead)) {
    return null;
  }

  const rpl = getRplFromLead(lead);
  const rows = buildRplFieldRows(rpl);

  if (rows.length === 0) {
    const fallbackMessage =
      lead.content?.message?.trim() || lead.metadata?.message?.trim() || '';

    return (
      <div className="sm:col-span-2">
        <dt className="text-sm font-medium text-gray-500 mb-4">
          {RPL_LEAD_TITLE}
        </dt>
        <dd className="mt-1 text-sm text-gray-700 whitespace-pre-wrap">
          {fallbackMessage || 'No structured RPL details were stored.'}
        </dd>
      </div>
    );
  }

  return (
    <div className="sm:col-span-2">
      <dt className="text-sm font-medium text-gray-500 mb-4">
        {RPL_LEAD_TITLE}
      </dt>
      <dd className="mt-1">
        <div className="rounded-lg border border-brand-200 bg-brand-50 p-4">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {rows.map((row) => (
              <div
                key={row.label}
                className={row.multiline ? 'sm:col-span-2' : undefined}
              >
                <div className="text-xs font-semibold uppercase tracking-wide text-brand-700">
                  {row.label}
                </div>
                <div
                  className={`mt-1 text-sm text-gray-900 ${
                    row.multiline ? 'whitespace-pre-wrap' : ''
                  }`}
                >
                  {row.value}
                </div>
              </div>
            ))}
          </div>
        </div>
      </dd>
    </div>
  );
}
